// NF-S1: Project Team API client. Backed by the api.js axios instance which
// unwraps the payload (returns data directly, not a response wrapper).
import api from '../services/api';

export const getTeam = (projectId) =>
  api.get(`/projects/${projectId}/team`);

export const getCandidates = (projectId) =>
  api.get(`/projects/${projectId}/team/candidates`);

export const addMember = (projectId, employeeId) =>
  api.post(`/projects/${projectId}/team`, { employeeId });

export const removeMember = (projectId, memberId) =>
  api.delete(`/projects/${projectId}/team/${memberId}`);
